import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useCanSeeFrontEndAdmin } from "shared/hooks/usePermissions";

export interface AdminLinkProps {
  title: string;
  route: string;
  children?: any;
}

const AdminLink = (props: AdminLinkProps) => {
  const canSeeAdmin = useCanSeeFrontEndAdmin();

  const { title, route, children } = props;

  return canSeeAdmin ? (
    <a href={route} title={title} target="_blank" rel="noreferrer">
      <FontAwesomeIcon icon="cogs" /> {children}
    </a>
  ) : null;
};

export default AdminLink;
